import { setApi, setEnv, setAppCode, setClientId } from './src/init';

export { getAuthManager, AUTH_MANAGER_EVENT } from './src/auth-manager';
export { getUserManager, USER_MANAGER_EVENT } from './src/user-manager';
export { getOrgManager, ORG_MANAGER_EVENT } from './src/org-manager';
export { getWxAuthManager } from './src/wx-auth-manager';
export { getWxSDKManager } from './src/wx-sdk-manager';

export function init(params: { defHttp: any; env: string; appCode: string; clientId?: string }) {
  setApi(params.defHttp);
  setEnv(params.env);
  setAppCode(params.appCode);
  setClientId(params.clientId || params.appCode);
}

export { setClientId } from './src/init';
